export const getQueryParam = (param: string) => {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  let val = params.get(param);
  return val;
};
